/** Shared call ringtone / wait / end audio helpers (singletons). */

let incomingEl: HTMLAudioElement | null = null;
let outgoingEl: HTMLAudioElement | null = null;
let endingCall = false;

function safePlay(el: HTMLAudioElement) {
  return el.play().catch((err) => {
    console.warn("Call sound blocked until user gesture:", err);
  });
}

export function startIncomingRingtone() {
  if (!incomingEl) {
    incomingEl = new Audio("/audio/ringtone.mp3");
  }
  incomingEl.pause();
  incomingEl.currentTime = 0;
  incomingEl.loop = true;
  void safePlay(incomingEl);
  return incomingEl;
}

export function stopIncomingRingtone() {
  if (!incomingEl) return;
  incomingEl.pause();
  incomingEl.currentTime = 0;
}

export function startOutgoingWaitSound() {
  if (endingCall) return;
  if (!outgoingEl) {
    outgoingEl = new Audio("/audio/outgoing_call_waitin_special_lyke.mp3");
  }
  outgoingEl.loop = true;
  void safePlay(outgoingEl);
}

export function stopOutgoingWaitSound() {
  if (!outgoingEl) return;
  outgoingEl.pause();
  outgoingEl.currentTime = 0;
}

export function stopAllCallSounds() {
  stopIncomingRingtone();
  stopOutgoingWaitSound();
}

/** One-shot end tone (reject / declined) — does not block hangup navigation. */
export function playCallEndSound() {
  stopAllCallSounds();
  try {
    const el = new Audio("/audio/call_end.mp3");
    el.loop = false;
    void el.play().catch(() => {});
  } catch {
    /* ignore */
  }
}

/**
 * Play hangup/end tone once, then run callback (navigate / reload).
 * Safe to call from multiple dispose paths — only one end sequence runs.
 */
export function playCallEndSoundThen(done: () => void) {
  stopAllCallSounds();
  if (endingCall) {
    // Already playing end tone / navigating — ignore duplicate dispose paths
    return;
  }
  endingCall = true;
  let finished = false;
  const finish = () => {
    if (finished) return;
    finished = true;
    endingCall = false;
    done();
  };

  try {
    const el = new Audio("/audio/call_end.mp3");
    el.loop = false;
    el.addEventListener("ended", finish, { once: true });
    window.setTimeout(finish, 2200);
    el.play().catch(() => finish());
  } catch {
    finish();
  }
}

export function clearCallSessionKeys() {
  try {
    sessionStorage.removeItem("callStartTime");
    sessionStorage.removeItem("call_chat_type");
    sessionStorage.removeItem("call_id");
    sessionStorage.removeItem("call_type");
    sessionStorage.removeItem("chat_id");
    sessionStorage.removeItem("room_id");
    sessionStorage.removeItem("is_caller");
    sessionStorage.removeItem("media_engine");
    sessionStorage.removeItem("livekit_token");
    sessionStorage.removeItem("livekit_peer_id");
    sessionStorage.removeItem("call_title");
    sessionStorage.removeItem("call_avatar");
    sessionStorage.removeItem("call_joined");
  } catch {
    /* ignore */
  }
}

/** Mark media session started (caller dial / callee Accept). */
export function markCallJoined() {
  try {
    sessionStorage.setItem("call_joined", "true");
  } catch {
    /* ignore */
  }
}
